import React, { useState } from "react";
import ClaimPointsModal from "../../modal/milesPoints/ClaimPointsModal";

function MilesPointsTaskCard({ task }) {
  const [modal, setModal] = useState(false);
  const coin =
    task.type === "gold"
      ? "/goldCoin.png"
      : task.type === "silver"
      ? "/silverCoin.png"
      : "/bronzeCoin.png";
  const done = task.done === task.total;
  const percent = (task.done / task.total) * 100;

  const handleClaim = () => {
    setModal(true);
  };

  return (
    <div className="border-t border-gray-200 w-full items-center justify-between py-4 flex">
      <ClaimPointsModal item={task} open={modal} setOpen={setModal} />
      <div className="flex items-center gap-4">
        <img src={coin} alt="" className="w-12 h-12 object-contain" />
        <div className="flex flex-1 flex-col gap-1">
          <span className="font-main font-bold text-lg">{task.title}</span>
          <p className="text-[#6D7C94] text-sm">{task.description}</p>
        </div>
      </div>
      <div className="flex items-center flex-col gap-1">
        <span className="text-base">+{task.points}</span>
        <div className="w-32 h-7">
          {done ? (
            <button
              className="w-full h-full rounded-lg bg-primary1 text-white text-xs font-bold"
              onClick={() => handleClaim()}
            >
              Claim
            </button>
          ) : (
            <div className="w-full h-full rounded-lg bg-[#F3F5F9] font-bold relative">
              <div
                className={`h-full  rounded-lg bg-[#06E775]`}
                style={{ width: `${percent}%` }}
              ></div>
              <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center text-[10px] text-black font-bold z-10">
                {task.done}/{task.total}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MilesPointsTaskCard;
